import styled from 'styled-components';

export const StyledIntroductionWrapper = styled.div`
  background-color: #38c2a0;
`;

export const StyledContainer = styled.div`
  padding-top: 24px;
  padding-bottom: 24px;
`;

export const StyledTitle = styled.h1`
  font-size: 3rem;
  text-align: center;
`;

export const StyledDescription = styled.div`
  text-align: justify;
  font-size: 14;
`;

export const ItalicText = styled.p`
  font-style: italic;
`; 

export const CenterAlignText = styled.p`
  text-align: center;
  font-size: 20px;
`; 

export const StyledLink = styled.a`
  color: #25c2a0;
`;